import React from 'react';

import type { CreateDialogContextType } from './create-dialog-context-types.ts';
import { getDefaultContextState } from './defaults.ts';

export const CreateDialogContext =
	React.createContext<CreateDialogContextType>(getDefaultContextState());

CreateDialogContext.displayName = 'CreateDialogContext';
